import { useId } from 'react';
import styles from './Logo.module.css';

/**
 * The Don Quack duck mark, optionally with the wordmark next to it.
 *
 * variant: 'gradient' (default) | 'mono' | 'dark'  — dark is for light backgrounds.
 * size:    pixel size of the mark.
 * withText: render the "Don Quack" wordmark beside the mark.
 */
export function Logo({ size = 30, variant = 'gradient', withText = true, className = '' }) {
  // useId keeps each instance's <linearGradient> id unique — two logos on one
  // page with the same id would make the second one render with no fill.
  const gradientId = useId();

  const fill =
    variant === 'gradient' ? `url(#${gradientId})`
    : variant === 'dark' ? 'var(--ink)'
    : 'var(--mist)';
  const eye = variant === 'dark' ? 'var(--mist)' : 'var(--ink)';

  return (
    <span className={`${styles.logo} ${className}`} style={{ '--logo-size': `${size}px` }}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
        {variant === 'gradient' && (
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#FF8A14" />
              <stop offset="1" stopColor="#FFC531" />
            </linearGradient>
          </defs>
        )}
        <circle cx="17" cy="18" r="11" fill={fill} />
        <path d="M26 15 L38 17.5 L26 21 Z" fill={fill} strokeLinejoin="round" />
        <circle cx="14.5" cy="14.5" r="2.1" fill={eye} />
        {variant === 'gradient' && <circle cx="15.3" cy="13.7" r=".75" fill="#fff" />}
      </svg>
      {withText && <span className={styles.wordmark}>Don Quack</span>}
    </span>
  );
}
